<template>
<moo-dialog custom-class="common-dialog folder-dialog" :append-to-body="true" :title="renameTitle" :visible.sync="visible" width="480px" :before-close="() => handleRenameDialog(false)">
    <div class="content">
      <div class="folder-input">
        <svg-icon class-name="folder-icon" :icon-class="fileIcon"></svg-icon>
        <moo-input maxlength="255" @keyup.enter.native="handleRenameFolder" class="common-input" v-model="folderName" :placeholder="$t('请输入名称#!!!#src/pages/H5/Cloud/components/dialog/renameDialog.vue_1')"></moo-input>
      </div>
      <div class="folder-path">{{ path }}</div>
    </div>
    <span slot="footer" class="dialog-footer">
      <moo-button class="cancel" @click="visible = false">{{$t("取 消#!!!#src/pages/H5/Cloud/components/dialog/renameDialog.vue_1")}}</moo-button>
      <moo-button class="submit" type="primary" @click="handleRenameFolder">{{$t("确 定#!!!#src/pages/H5/Cloud/components/dialog/renameDialog.vue_1")}}</moo-button>
    </span>
  </moo-dialog>
</template>

<script>
import { intl } from 'tci18n-vue2'
import { renameFileTitle } from "@/api/h5/file";
import { debounce } from "@/utils/lodash";
import utils from "@/core/h5/utils";
import { fileImgName } from "@/utils/avatar";

export default {
  props: {
    folderPath: {
      type: String,
      default: ""
    },
    metadata: {
      type: Object
    }
  },
  name: "RenameDialog",
  components: {},
  data() {
    return {
      visible: false,
      folderName: "",
      fileType: "",
      data: null
    };
  },
  methods: {
    handleRenameDialog(value, item) {
      this.visible = value;
      this.data = item;
      if (value) {
        if (item.contentType == "FOLDER") {
          this.folderName = item.fileName;
        } else {
          this.folderName = utils.getFileName(item?.fileName);
          this.fileType = utils.getExt(item?.fileName);
        }
      } else {
        this.folderName = "";
      }
    },
    handleRenameFolder: debounce(async function () {
      const regex = /[\\/:*?"<>|]/;
      if (regex.test(this.folderName)) {
        this.$message({
          message: intl.$t("新建失败，文件名不能包含非法字符: / : * ? < > | '#!!!#src/pages/H5/Cloud/components/dialog/renameDialog.vue_1"),
          type: "error"
        });
        return;
      }
      try {
        const { code, message, data = {} } = await renameFileTitle({
          fileId: this.data?.fileId,
          fileName:
          this.folderName + (this.fileType ? "." : "") + this.fileType
        });
        if (code == 200) {
          this.$emit("refresh");
          this.$message({ message: intl.$t("重命名成功#!!!#src/pages/H5/Cloud/components/dialog/renameDialog.vue_1"), type: "success" });
          this.handleRenameDialog(false);
        } else {
          this.$message({ message, type: "error" });
        }
      } catch (err) {
        this.$message({ message: intl.$t("重命名失败#!!!#src/pages/H5/Cloud/components/dialog/renameDialog.vue_1"), type: "error" });
      }
    }),
    getFileIcon(item) {
      const { fileName, type, contentType = "" } = item;
      if (contentType == "DOCUMENT") {
        return "cloud-online-doc";
      }
      if (type !== "0") return "cloud-folder";
      const name = fileName.trim();
      const index = name.lastIndexOf(".");
      if (index === -1) return "cloud-other";
      const ext = name.substr(index).replace(".", "");
      return fileImgName(ext);
    }
  },

  computed: {
    path() {
      return this.folderPath + "/" + this.folderName;
    },
    renameTitle() {
      return this.data?.type === "0" ? intl.$t("重命名文件#!!!#src/pages/H5/Cloud/components/dialog/renameDialog.vue_1") : intl.$t("重命名文件夹#!!!#src/pages/H5/Cloud/components/dialog/renameDialog.vue_1");
    },
    fileIcon() {
      if (this.data) {
        return this.getFileIcon(this.data);
      }
      return "cloud-folder";
    }
  },
  watch: {},
  mounted() {},
  destroyed() {}
};
</script>

<style lang="scss">
.common-dialog {
  border-radius: 8px !important;

  .moo-dialog__header {
    font-size: 17px;
    color: #000;
    font-weight: 500;
    box-shadow: 0 0.5px rgba(0, 0, 0, 0.11);
  }

  .moo-dialog__footer {
    height: 50px;
    box-shadow: 0 -0.5px rgba(0, 0, 0, 0.11);

    .dialog-footer {
      .cancel {
        outline: none;
        padding: 0;
        color: #222329;
        background: #fff;
        border: 1px solid #e8e9ee;
        font-size: 14px;
        font-weight: 400;
        height: 30px;
        width: 100px;
        border-radius: 4px;
      }

      .submit {
        outline: none;
        color: #fff;
        background: #5c70ff;
        border: none;
        box-shadow: inset -0.5px 0.5px rgba(0, 0, 0, 0.3),
          inset 0.5px -0.5px rgba(0, 0, 0, 0.3);
        font-size: 13px;
        font-weight: 400;
        padding: 0;
        height: 30px;
        width: 100px;
        border-radius: 4px;
      }
    }
  }
}

.folder-dialog {
  .moo-dialog__body {
    .content {
      display: flex;
      flex-flow: column;
      width: 100%;

      .folder-input {
        display: flex;
        flex-flow: row;
        justify-content: center;
        width: 100%;

        .folder-icon {
          width: 35px;
          height: 35px;
          margin-right: 8px;
        }
      }

      .folder-path {
        margin-top: 2px;
        padding-left: 43px;
        font-size: 12px;
        color: rgba(0, 0, 0, 0.5);
      }
    }
  }
}

.common-input {
  display: block;
  flex: 1;

  input {
    height: 30px;
    border: 1px solid rgba(0, 0, 0, 0.3);
    border-radius: 4px;
  }
}
</style>
